import React, { useEffect, useState } from 'react';
const DAYS = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
const MONTHS = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
const getSecondsUntilEndOfDay = () => {
  const now = new Date();
  const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
  return Math.max(0, Math.floor((endOfDay.getTime() - now.getTime()) / 1000));
};
const getTodayLabel = () => {
  const now = new Date();
  return `${DAYS[now.getDay()]} ${now.getDate()} de ${MONTHS[now.getMonth()]}`;
};
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(getSecondsUntilEndOfDay);
  const [todayLabel, setTodayLabel] = useState(getTodayLabel);
  useEffect(() => {
    const interval = setInterval(() => {
      const remaining = getSecondsUntilEndOfDay();
      setTimeLeft(remaining);
      // If we just crossed midnight, refresh the date label too
      if (remaining > 86390) {
        setTodayLabel(getTodayLabel());
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className="bg-gray-900 text-white py-3 px-4 sticky top-0 z-50 shadow-lg animate-neon-red" data-id="element-404">
      <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-405">
        <div className="flex flex-col" data-id="element-406">
          <span className="text-sm md:text-base font-black tracking-wide text-red-500 drop-shadow-[0_0_8px_rgba(220,38,38,0.8)]" data-id="element-407">
            ¡OFERTA LANZAMIENTO!
          </span>
          <span className="text-xs md:text-sm font-semibold text-red-300" data-id="element-408">
            Finaliza hoy {todayLabel}
          </span>
        </div>

        <div className="flex items-center gap-1 md:gap-2" data-id="element-409">
          <div className="bg-black border border-red-600 rounded-md px-2 md:px-3 py-1 md:py-2 text-center min-w-[40px] md:min-w-[52px]" data-id="element-410">
            <span className="text-lg md:text-2xl font-black tabular-nums text-red-500 font-mono drop-shadow-[0_0_8px_rgba(220,38,38,0.8)]" data-id="element-411">
              {pad(hours)}
            </span>
            <p className="text-[8px] md:text-[10px] font-bold text-red-400/70 uppercase tracking-wider" data-id="element-412">
              HRS
            </p>
          </div>
          <span className="text-xl md:text-2xl font-black text-red-500 drop-shadow-[0_0_8px_rgba(220,38,38,0.8)]" data-id="element-413">
            :
          </span>
          <div className="bg-black border border-red-600 rounded-md px-2 md:px-3 py-1 md:py-2 text-center min-w-[40px] md:min-w-[52px]" data-id="element-414">
            <span className="text-lg md:text-2xl font-black tabular-nums text-red-500 font-mono drop-shadow-[0_0_8px_rgba(220,38,38,0.8)]" data-id="element-415">
              {pad(minutes)}
            </span>
            <p className="text-[8px] md:text-[10px] font-bold text-red-400/70 uppercase tracking-wider" data-id="element-416">
              MIN
            </p>
          </div>
          <span className="text-xl md:text-2xl font-black text-red-500 drop-shadow-[0_0_8px_rgba(220,38,38,0.8)]" data-id="element-417">
            :
          </span>
          <div className="bg-black border border-red-600 rounded-md px-2 md:px-3 py-1 md:py-2 text-center min-w-[40px] md:min-w-[52px]" data-id="element-418">
            <span className="text-lg md:text-2xl font-black tabular-nums text-red-500 font-mono drop-shadow-[0_0_8px_rgba(220,38,38,0.8)]" data-id="element-419">
              {pad(seconds)}
            </span>
            <p className="text-[8px] md:text-[10px] font-bold text-red-400/70 uppercase tracking-wider" data-id="element-420">
              SEG
            </p>
          </div>
        </div>
      </div>
    </div>;
}